import {setDefaultOptions} from 'date-fns';
import {enUS} from 'date-fns/locale';
import configStore from '@deezer/next/services/config';
import D4CToolsStorage from '@deezer/next/components/D4CTools/D4CToolsStorage';
import {createStandaloneToast} from '@deezer/next/shared/hooks/useToast';

export const initGlobal = () => {
	if (typeof window !== 'undefined') {
		window.D4C = {
			getApiUrls: () => ({
				starmania: `https://${configStore.get('API_HOST')}`,
				legacy: `https://${configStore.get('LEGACY_API_HOST')}`,
			}),
			tools: D4CToolsStorage,
			closeAllToasts: () => {
				const {toast} = createStandaloneToast();
				toast.closeAll();
			},
		};
		document.body.setAttribute('d4c-window-ready', 'true');
	}
};

export const initDateLocale = () => {
	setDefaultOptions({locale: enUS});
};
